import * as Yup from 'yup';
// Define a validation schema for the signup form
const phoneRegExp = /^[6-9]\d{9}$/;  // Regex for validating Indian mobile numbers starting with 6-9 and having 10 digits

const matchkarosignupSchema = Yup.object().shape({
        mobile: Yup.string()
        .required('Mobile Number is required.').matches(phoneRegExp, 'Mobile number is not valid'),  // Validates the mobile number format
});

export default matchkarosignupSchema;